<template>
  <!-- 保单管理 -->
  <div class="insuredOrder main-container">
    <div class="content">
      <div class="search-box btn3" :class="{ 'close': !searchMore }">
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" :transfer="true" filterable clearable>
            <Option v-for="(item, i) in companyList" :key="i" :value="item.code">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.dateType" :transfer="true">
            <Option value="1">录单时间</Option>
            <Option value="2">投保日期</Option>
            <Option value="3">生效日期</Option>
            <Option value="4">承保时间</Option>
            <Option value="5">支付时间</Option>
          </Select>
          <DatePicker
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :value="searchParams.date"
            @on-change="searchParams.date = $event"
          ></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">保单号</span>
          <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">保单状态</span>
          <Select v-model="searchParams.status" :transfer="true" clearable>
            <Option value="1">已承保</Option>
            <Option value="-1">已退保</Option>
            <Option value="2">已中止</Option>
            <Option value="0">已终止</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.userType" :transfer="true">
            <Option value="1">投保人</Option>
            <Option value="2">被保险人</Option>
          </Select>
          <Input v-model="searchParams.name" placeholder="姓名/手机号" clearable />
        </div>
        <div class="input-item" v-if="$units.isOkBao() || $units.isOkTX()">
          <span class="label">投保人证件号</span>
          <Input v-model="searchParams.holderIdNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item select-two select-two1">
          <Select
            v-model="searchParams.selectType"
            :transfer="true"
            @on-change="
              searchParams.verifyStatus = '';
              searchParams.doubleRecordStatus = '';
            "
          >
            <Option value="1">回执回访状态</Option>
            <Option value="2">双录状态</Option>
          </Select>
          <Select v-if="searchParams.selectType == 1" v-model="searchParams.receiptRevisitSatus" :transfer="true" clearable>
            <Option value="1">待回执</Option>
            <Option value="2">待回访</Option>
            <Option value="3">回执回访成功</Option>
          </Select>
          <lzDicSelect v-if="searchParams.selectType == 2" v-model="searchParams.doubleRecordStatus" dicType="DOUBLE_STATUS" transfer clearable></lzDicSelect>
        </div>
        <div class="input-item">
          <span class="label">业务类别</span>
          <Select v-model="searchParams.sellType" :transfer="true" clearable>
            <Option value="1">网销</Option>
            <Option value="2">电销</Option>
            <Option value="3">经代</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">是否自保件</span>
          <RadioGroup v-model="searchParams.isSelfHold" @on-change="searchAjax()">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">是否互保件</span>
          <RadioGroup v-model="searchParams.isMutualHold" @on-change="searchAjax()">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">长短险标志</span>
          <RadioGroup v-model="searchParams.periodType" @on-change="searchAjax">
            <Radio label="">全部</Radio>
            <Radio label="1">长险</Radio>
            <Radio label="2">短险</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">所属机构</span>
          <selectTree
            type="4"
            v-model="searchParams.organIds"
            @change="getGroupList"
            ref="selectTree"
            :selectAll="false"
            :maxTagCount="1"
            :multiple="true"
          ></selectTree>
        </div>
        <div class="input-item">
          <span class="label">所属团队</span>
          <Select v-model="searchParams.groupIds" clearable multiple :max-tag-count="1" filterable>
            <Option v-for="(bean, i) in groupList" :key="i" :value="bean.groupId">
              {{ bean.groupCode ? bean.groupName + '-' + bean.groupCode : bean.groupName }}
            </Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">出单业务员</span>
          <lzSelect placeholder="请输入姓名或工号搜索" v-model="searchParams.salesmanId" :remote-method="getUserList">
            <template slot-scope="{ list }">
              <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name">
                <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
                {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
              </Option>
            </template>
          </lzSelect>
        </div>
        <div class="input-item">
          <span class="label">录单人员</span>
          <Select v-model="searchParams.enterUserId" :transfer="true" clearable filterable>
            <Option v-for="(item, i) in sysUserList" :key="i" :value="item.id">{{ item.userName }}</Option>
          </Select>
        </div>
        <div class="input-item" v-if="$units.isOkBao() || $units.isRYBB()">
          <span class="label">个险销售支持</span>
          <Select v-model="searchParams.salesSupportId" clearable filterable>
            <Option v-for="(item, i) in salesSupportList" :key="i" :value="item.id" :label="item.name"></Option>
          </Select>
        </div>
        <div class="input-item" v-if="$units.showSupplier() && $units.pointAction('order_30_13')">
          <span class="label">供应商类型</span>
          <RadioGroup v-model="searchParams.supplierType" @on-change="changeOriginSupplierType">
            <Radio label="">全部</Radio>
            <Radio label="1">保司</Radio>
            <Radio label="2">通道</Radio>
          </RadioGroup>
        </div>
        <div v-if="searchParams.supplierType && $units.showSupplier() && $units.pointAction('order_30_13')" class="input-item">
          <span class="label">供应商</span>
          <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable transfer>
            <Option v-for="item in supplierList" :key="item.value" :value="item.value">{{ item.label }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">订单号</span>
          <Input v-model="searchParams.orderNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">投保单号</span>
          <Input v-model="searchParams.proposalNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">备注</span>
          <Input v-model="searchParams.remark" placeholder="请输入关键词" clearable />
        </div>
        <div v-if="$units.isOkTX() || $units.isOkBao() || $units.isRYBB()" class="input-item">
          <span class="label">推广执行人</span>
          <lzDicSelect v-model="searchParams.executer" dicType="USER_EXECUTER" :transfer="true" clearable> </lzDicSelect>
        </div>
        <div v-if="$units.isOkTX() || $units.isOkBao() || $units.isRYBB()" class="input-item">
          <span class="label">推广渠道</span>
          <lzDicSelect v-model="searchParams.channel" dicType="USER_CHANNEL" :transfer="true" clearable> </lzDicSelect>
        </div>

        <div class="input-item">
          <div class="policy-search-box">
            <Poptip placement="bottom" width="600">
              <Tooltip
                placement="top"
                content="输入多个保单号批量搜索"
                transfer
                :disabled="searchParams.policyNoList && searchParams.policyNoList.split('\n').filter(item => item).length ? true : false"
              >
                <Button type="primary" icon="ios-search">批量查询</Button>
              </Tooltip>
              <div class="api policy-num" slot="content">
                <span class="title">请输入保单号，多个保单号换行输入</span>
                <Input v-model="searchParams.policyNoList" :rows="7" type="textarea" />
                <div class="text">
                  <Poptip placement="bottom" trigger="hover" style="width: 60px" width="250">
                    <div class="example-text">输入示例</div>
                    <div class="api policy-num" slot="content">
                      <div class="tip">每一行一个保单号</div>
                      <Input v-model="policyExample" :rows="5" type="textarea" disabled />
                    </div>
                  </Poptip>
                  <div
                    class="clearable"
                    @click="searchParams.policyNoList = ''"
                    v-if="searchParams.policyNoList && searchParams.policyNoList.split('\n').filter(item => item).length"
                  >
                    清空
                  </div>
                </div>
              </div>
            </Poptip>
            <div class="tip-nums" v-if="searchParams.policyNoList">
              {{ searchParams.policyNoList && searchParams.policyNoList.split('\n').filter(item => item).length }}
            </div>
          </div>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
            >收起
            <Icon type="ios-arrow-up" />
          </Button>
          <Button type="primary" ghost v-else @click="searchMore = true"
            >展开
            <Icon type="ios-arrow-down" />
          </Button>
        </div>
      </div>

      <div class="sedTab" v-if="isShowSed">
        <ul class="filterTab">
          <li :class="{ active: curActive == index }" v-for="(item, index) in sendTab" :key="index" @click="toggleSecondTab(index, item)">
            {{ item.label }}
          </li>
        </ul>
      </div>
      <div class="tipBox clearfix">
        <div class="left clearfix" v-if="$units.superviseShowVal()">
          <div v-if="$units.pointAction('order_30_6')">
            <Checkbox v-model="isAll" @on-change="handleCheckAll"></Checkbox>
            已选
            <span class="total">{{ isAll ? total : checkItemsList.length }}</span>
            单， 共
            <span class="total">{{ total }}</span
            >单
          </div>
          <div v-else>
            共
            <span class="total">{{ total }}</span
            >单
          </div>

          <div v-if="!hiddenTxt">
            已支付保费：
            <span class="other">{{ countObj.payedAmount || '0.00' }}</span
            >元
          </div>
          <div v-if="!hiddenTxt">
            已支付标保：
            <span class="other">{{ countObj.payedFoldFyb || '0.00' }}</span
            >元
          </div>

          <div>
            退款保费：
            <span class="other">{{ countObj.refundedAmount || '0.00' }}</span
            >元
          </div>
          <div>
            退款标保：
            <span class="other">{{ countObj.refundedFoldFyb || '0.00' }}</span
            >元
          </div>
        </div>
        <Button
          type="primary"
          class="right"
          ghost
          @click="$refs.daochuModal.open(searchParams)"
          v-if="$units.pointAction('order_30_4') && $units.superviseShowVal()"
          >导出</Button
        >
        <Button type="primary" class="right-del" v-if="$units.pointAction('order_30_6')" ghost @click="batchDelete">批量删除</Button>
      </div>
      <loading :isShow="listLoading" />
      <div class="tableBox setTable" v-if="listLoading || insureList.length">
        <div class="tableHead">
          <Checkbox
            class="page-check"
            v-if="$units.pointAction('order_30_6')"
            v-model="isCheckPage"
            :disabled="isAll"
            @on-change="handleCheckPage()"
          ></Checkbox>
          <div class="item name left">业务类别/产品/险种名称</div>
          <div class="item name">保费（元）</div>
          <div class="item name">公司标保（元）</div>
          <div class="item name" v-if="$units.pointAction('order_30_9')">
            服务费（元）
            <Poptip trigger="hover" v-if="userInfo.userType != 4">
              <Icon type="ios-help-circle-outline" size="18" color="#fff" style="margin-left: -6px; margin-top: 2px" />
              <div slot="content" style="color: #333">当前机构服务费，包含给下级机构和业务员的服务费</div>
            </Poptip>
          </div>
          <div class="item name1">保单/险种状态</div>
          <div class="item name1">长短险标志</div>
          <div class="item name">回执回访状态</div>
          <div class="item name">出单业务员</div>
          <div class="item action" ref="operation">操作</div>
        </div>
        <div class="items" v-for="item in insureList" :key="item.id">
          <div class="tableTip">
            <Checkbox
              v-if="$units.pointAction('order_30_6')"
              v-model="item._checked"
              :disabled="item._disabled"
              @on-change="handleCheckItem($event, item)"
            ></Checkbox>
            <div class="item">
              <span>承保时间:</span>
              <span>{{ item.insureTime | filterTime('YYYY-MM-DD') }}</span>
            </div>
            <div class="item">
              <span>保单号:</span>
              <span>{{ item.policyNo }}</span>
            </div>
            <div class="item">
              <span>投/被保险人:</span>
              <span>{{ item.holderName }}/{{ item.insuranceName }}</span>
            </div>
            <!-- <div class="item">
              <span>手机号:</span>
              <span>{{ item.holderMobile }}</span>
            </div> -->
            <div class="item" v-if="$units.showSupplier() && $units.pointAction('order_30_13')">
              <span>供应商:</span>
              <span>{{ item.supplierName }}</span>
            </div>
            <div class="item" v-if="item.planProductCode">
              <span>供应商产品id:</span>
              <span>{{ item.planProductCode }}</span>
            </div>
            <div class="item" v-if="item.executer">
              <span>推广执行人:</span>
              <lzDicTxt v-if="item.executer" dicType="USER_EXECUTER" :dicCode="item.executer"></lzDicTxt>
            </div>
            <div class="item" v-if="item.channel">
              <span>推广渠道:</span>
              <lzDicTxt v-if="item.channel" dicType="USER_CHANNEL" :dicCode="item.channel"></lzDicTxt>
            </div>
            <div class="item last">
              <span>所属团队:</span>
              <span v-if="item.groupName">{{ item.orgName }}/{{ item.groupName }}</span>
              <span v-else>{{ item.orgName }}</span>
            </div>
            <div class="item" v-if="item.source">
              <span>产品来源:</span>
              <span>{{ item.source }}</span>
            </div>
          </div>
          <div class="tBody" :class="{ 'p-b': item.hasAdditional }">
            <div class="top">
              <div class="item name">
                <span class="sellTypeColumn" v-if="item.sellTypes">
                  <Tag color="blue" v-if="item.sellTypes.includes('1')">网销</Tag>
                  <Tag color="blue" v-if="item.sellTypes.includes('2')">电销</Tag>
                  <Tag color="blue" v-if="item.sellTypes.includes('3')">经代</Tag>
                </span>
                <span v-else>-</span>
                {{ item.productName }}({{ item.productCode }})
              </div>
              <div class="item name">{{ item.fee }}</div>
              <div class="item name">{{ item.foldFyb }}</div>
              <div class="item name" v-if="$units.pointAction('order_30_9')">
                <span v-if="item.noCommissionReason && !item.hasAdditional" class="red">{{ item.noCommissionReason }}</span>
                <span v-else>{{ item.totalCommission }}</span>
              </div>
              <div class="item name1">
                <!-- <span style="position: relative"> -->
                {{ item.status | dealStatus }}
                <!-- <span
                    class="verifyBox"
                    v-if="
                      (item.verifyStatus == 0 || item.verifyStatus == 2) &&
                      item.verifyStatus
                    "
                    >{{ item.verifyStatus | dealVerifyStatus }}</span
                  >
                </span> -->
              </div>
              <div class="item name1">
                <span v-if="item.periodType == 1">长险</span>
                <span v-if="item.periodType == 2">短险</span>
              </div>
              <div class="item name">
                <span v-if="item.receiptStatus || item.verifyStatus">{{ showReceiptRevisit(item) }}</span>
                <Poptip trigger="hover" word-wrap width="500">
                  <Icon v-if="item.receiptStatus || item.verifyStatus" type="ios-help-circle-outline" size="18" />
                  <div slot="content" style="color: #333">
                    <span>回执回访记录：</span>
                    <div v-if="item.detailList && item.detailList.length > 0">
                      <div v-for="(i, index1) in item.detailList" :key="index1">
                        <span v-if="i.updateTime">{{ i.updateTime | filterTime('YYYY-MM-DD') }}&nbsp;</span>
                        <lzDicTxt dicType="RECEIPT_STATUS" :dicCode="i.receiptStatus" v-if="i.receiptStatus"> </lzDicTxt>
                        <lzDicTxt dicType="VERIFY_STATUS" :dicCode="i.revisitStatus" v-if="i.revisitStatus"> </lzDicTxt>
                        <span v-if="i.remark">&nbsp;{{ i.remark }}</span>
                      </div>
                    </div>
                    <div v-else>无</div>
                  </div>
                </Poptip>
              </div>
              <div class="item name">{{ item.salesmanName }}</div>
              <div class="item action"></div>
            </div>
            <div class="main" v-if="item.hasAdditional">
              <div class="item name">
                {{ item.mainProductName }}
              </div>
              <div class="item name">{{ item.mainFee }}</div>
              <div class="item name">{{ item.mainFoldFyb }}</div>
              <div class="item name" v-if="$units.pointAction('order_30_9')">
                <span v-if="item.noCommissionReason" class="red">{{ item.noCommissionReason }}</span>
                <span v-else>{{ item.commission }}</span>
              </div>
              <div class="item name1">{{ item.status | dealStatus }}</div>
              <div class="item name"></div>
              <div class="item name1"></div>
              <div class="item name"></div>
              <div class="item action"></div>
            </div>
            <div class="other" v-if="item.hasAdditional">
              <div class="list" v-for="(items, indexs) in item.policyAdditionalList" :key="indexs">
                <!-- order_30_9 费用权限 -->
                <div
                  class="item name"
                  :class="{ inrWidth: idx == 0, 'name1': its.key === 'settlementStatus' || its.key === 'status', 'action': its.key === 'action' }"
                  v-for="(its, idx) in policyAdditionalList"
                  :key="idx"
                  v-if="$units.pointAction('order_30_9') || its.key != 'commission'"
                >
                  <span v-if="idx == 2">{{ items.foldFyb }}</span>
                  <span v-else-if="its.key === 'status'">{{ items[its.key] | dealStatus }}</span>
                  <lzDicTxt v-else-if="its.key === 'receiptRevisitStatus'" dicType="RECEIPT_REVISIT_STATUS" :dicCode="item.receiptRevisitStatus"></lzDicTxt>
                  <span v-else-if="$units.pointAction('order_30_9') && its.key == 'commission'">
                    <span v-if="items.noCommissionReason" class="red">{{ items.noCommissionReason }}</span>
                    <span v-else>{{ items[its.key] }}</span>
                  </span>
                  <span v-else-if="its.key != 'commission' && its.key != 'status'">{{ items[its.key] }}</span>
                </div>
              </div>
            </div>

            <!-- entrance 1、线上 2、商户端录入 3、运营后台录入 -->
            <div class="bar-action" v-if="item.entrance == 2 || item.entrance == 3" :class="{ 'no-add-insurance': !item.hasAdditional }">
              <div class="action">
                <a class="actionStyle" @click="handlerPolicyDetail(item)">详情</a>
                <a class="actionStyle" v-if="$units.pointAction('order_30_2') && item.entrance == 2" @click="modifyPolicy('edit', item)">编辑</a>
                <Dropdown :transfer="true" trigger="hover" @on-click="dropdownClick($event, item)" v-if="item.entrance == 2">
                  <div class="more-btn">
                    更多
                    <Icon type="ios-arrow-down"></Icon>
                  </div>
                  <DropdownMenu slot="list">
                    <DropdownItem name="copy" v-if="$units.pointAction('order_30_11') && item.entrance == 2 && item.sourceType == 2">复制</DropdownItem>
                    <DropdownItem name="change" v-if="$units.superviseShowVal()">变更记录</DropdownItem>
                    <DropdownItem
                      name="underlinePolicy"
                      v-if="$units.pointAction('order_30_7') && ((item.insuranceContract && item.insuranceContract.length != 0) || item.dockChannel == 3)"
                      >电子保单</DropdownItem
                    >
                    <DropdownItem name="delete" v-if="$units.pointAction('order_30_6') && item.entrance == 2 && item.sourceType == 2">删除</DropdownItem>
                    <DropdownItem v-if="item.dockChannel == 3 && item.dataSource == 'API'" name="policyVideo">回溯记录</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>

            <div class="bar-action" v-else :class="{ 'no-add-insurance': !item.hasAdditional }">
              <div class="action">
                <a class="actionStyle" @click="$refs.detailModal.open(item)">详情</a>
                <Dropdown
                  :transfer="true"
                  trigger="hover"
                  v-if="$units.pointAction('order_30_7') || item.dataSource == 'API'"
                  @on-click="dropdownClick($event, item)"
                >
                  <div class="more-btn">
                    更多
                    <Icon type="ios-arrow-down"></Icon>
                  </div>
                  <DropdownMenu slot="list">
                    <DropdownItem name="policy" v-if="$units.pointAction('order_30_7')">电子保单</DropdownItem>
                    <DropdownItem v-if="item.dataSource == 'API'" name="policyVideo">回溯记录</DropdownItem>
                    <!-- <DropdownItem name="associationChannel" v-if="$units.isOkBao()">关联合伙渠道</DropdownItem> -->
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <no-data v-else></no-data>
      <div class="pageBox" v-if="insureList.length">
        <Page
          :total="total"
          :current="searchParams.pageNo"
          :page-size="searchParams.pageSize"
          show-total
          @on-change="pageChange"
          show-sizer
          :page-size-opts="[10, 20, 30, 50, 100]"
          @on-page-size-change="pageSizeChange"
          style="text-align: center"
        />
      </div>
    </div>

    <!-- 线下保单详情 -->
    <policyDetail ref="policyDetailRef"></policyDetail>
    <!-- 线上保单详情  -->
    <detailModal ref="detailModal"></detailModal>
    <!-- 电子保单地址 -->
    <a ref="policyNoBox" :href="policyNo" target="_black"></a>
    <!-- 下载全部电子保单  -->
    <Modal v-model="showDownloadAll" title="下载全部电子保单" @on-ok="confirmEmail" width="500" :loading="$root.$children[0].modalLoading">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
        <FormItem prop="email" label="邮箱">
          <Input v-model="formValidate.email" placeholder="请输入您的电子邮箱" />
        </FormItem>
      </Form>
    </Modal>
    <!-- 导出保单  -->
    <daochu-modal ref="daochuModal"></daochu-modal>
    <!-- 导入保单  -->
    <import-modal ref="importModal" code="policy" title="批量导入普通单"></import-modal>

    <!-- 变更记录 -->
    <change-record ref="changeRecord"></change-record>

    <Modal v-model="showPolicy" title="电子保单" width="800" :loading="$root.$children[0].modalLoading" footer-hide>
      <resource ref="resourceRef" :urlList="urlList" width="100px" height="100px"></resource>
    </Modal>

    <infoCheck ref="infoCheckRef" @reload="policyVideo" />

    <noPolicyNumberModal ref="noPolicyNumberRef"></noPolicyNumberModal>

    <!-- 关联合伙渠道 -->
    <associationChannel ref="associationChannelRef" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import noPolicyNumberModal from './components/noPolicyNumberModal';
import associationChannel from './components/associationChannel';
import infoCheck from './components/infoCheck';
import resource from '@/components/commons/resource'; //资源列表
import lzDicSelect from '@/components/commons/lzDicSelect';
import detailModal from './components/detailModal';
import policyDetail from './components/policyDetail';
import daochuModal from './components/daochuModal';
import importModal from './components/importConfig/importModal';
import changeRecord from './components/changeRecord';
import myForm from '@/components/commons/form';
import { mapState } from 'vuex';
import { pageTool, common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzSelect from '@/components/commons/lzSelect';
import { getInsureStatistics } from '@/api/httpList';

export default {
  mixins: [pageTool, common],
  components: {
    noPolicyNumberModal,
    daochuModal,
    lzDicTxt,
    selectTree,
    importModal,
    associationChannel,
    changeRecord,
    detailModal,
    myForm,
    policyDetail,
    lzDicSelect,
    lzSelect,
    resource,
    infoCheck
  },
  props: ['show'],
  data() {
    return {
      formValidate: {
        email: ''
      },
      groupList: [],
      salesSupportList: [], //个险销售支持
      groupSalesSupportList: [], //团险销售支持
      ruleValidate: {
        email: [
          {
            required: true,
            message: '请输入验证码'
          },
          {
            pattern: /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
            message: '请输入正确的邮箱'
          }
        ]
      },
      urlList: [], //资源列表
      showPolicy: false,
      showDownloadAll: false,
      hiddenTxt: false,
      policyNo: '',
      detailInfo: {},
      sendTab: [],
      tab: '',
      isShowSed: false,
      curActive: 0,
      policyAdditionalList: [
        {
          key: 'name',
          name: '产品/险种名称'
        },
        {
          key: 'fee',
          name: '保费（元）'
        },
        {
          key: 'mainFoldFyb',
          name: '公司标保（元）'
        },
        {
          key: 'commission',
          name: '服务费（元）'
        },
        {
          key: 'status',
          name: '保单/险种状态'
        },
        {
          key: '',
          name: ''
        },
        {
          key: 'settlementStatus',
          name: ''
        },
        {
          key: '',
          name: ''
        },
        {
          key: 'action',
          name: ''
        }
      ],
      sendTabbase: [
        {
          label: '全部',
          value: '1'
        },
        {
          label: '未生效',
          value: '2'
        },
        {
          label: '已生效未过犹',
          value: '3'
        },
        {
          label: '部分退保',
          value: '4'
        },
        {
          label: '已过犹',
          value: '5'
        }
      ],
      sendTabother: [
        {
          label: '全部',
          value: '1'
        },
        {
          label: '犹内退保',
          value: '6'
        },
        {
          label: '犹外退保',
          value: '7'
        }
      ],
      countObj: {}, //统计数据
      searchParams: {
        isAbnormal: '0',
        applyOrgId: '',
        policyNo: '',
        isSelfHold: '',
        isMutualHold: '',
        dateType: '4',
        userType: '1',
        selectType: '1',
        pageNo: 1,
        pageSize: 10
      },
      insureList: [],
      recordList: [],
      total: 0,
      showOrderdetail: false,
      //表单搜索字段
      searchForm: [],
      columns: [],
      companyList: [],
      sysUserList: [],
      draftCount: 0,
      supplierList: [],
      isAll: false,
      checkAllGroup: [],
      isCheckPage: false,
      RECEIPT_STATUS: JSON.parse(localStorage.getItem('dic')).RECEIPT_STATUS, //回执状态
      VERIFY_STATUS: JSON.parse(localStorage.getItem('dic')).VERIFY_STATUS, //回访状态
      checkItemsList: [],
      policyExample: '0012346464351321\nFFVFGTY42311131F\nWWDFERRTW2243543\nOPKUHNGY4323234F\n...'
    };
  },
  watch: {
    payStatus(value) {
      if (value == 1) {
        this.sendTab = _.cloneDeep(this.sendTabbase);
        this.isShowSed = true;
        this.hiddenTxt = false;
      } else if (value == -1) {
        //已退保
        this.hiddenTxt = true;
        this.sendTab = _.cloneDeep(this.sendTabother);
        this.isShowSed = true;
      } else {
        this.isShowSed = false;
        this.hiddenTxt = false;
      }
      this.curActive = 0;
      this.searchParams.secondTab = ''; //复位二级tab
      this.getInsureList();
    },
    show: {
      handler(newVal) {
        if (!newVal) {
          this.$refs.importModal.visibleSmall = false;
        } else {
          this.$refs.importModal.visibleSmall = true;
        }
      }
    },
    immediate: true
  },
  computed: {
    ...mapState(['userInfo']),
    payStatus() {
      return this.searchParams.status;
    }
  },
  filters: {
    //保单险种状态
    dealStatus(val) {
      const m = new Map([
        ['1', '已承保'],
        ['-1', '已退保'],
        ['2', '已中止'],
        ['0', '已终止']
      ]);
      return m.get(val + '');
    },
    //结算状态
    dealComStatus(val) {
      const m = new Map([
        ['0', '未结算'],
        ['1', '已结算']
      ]);
      return m.get(val + '');
    },
    //回访状态
    dealVerifyStatus(val) {
      const m = new Map([
        ['0', '等待回访'],
        ['1', '回访成功'],
        ['2', '回访失败'],
        ['3', '无需回访']
      ]);
      return m.get(val + '');
    }
  },
  methods: {
    // 获取个险、团险销售支持
    getOkBaoSalesSupport() {
      this.$http({
        url: '/buz/userBase/okbao/getSalesSupport',
        type: 'GET',
        data: {
          type: 1
        }
      }).then(res => {
        if (res.data) {
          this.salesSupportList = res.data;
        }
      });
      // this.$http({
      //   url: '/buz/userBase/okbao/getSalesSupport',
      //   type: 'GET',
      //   data: {
      //     type: 2
      //   }
      // }).then(res => {
      //   if(res.data) {
      //     this.groupSalesSupportList = res.data;
      //   }
      // });
    },
    // 业务员搜索
    getUserList(keyword) {
      if (!keyword) {
        return;
      }
      let params = {
        orgId: this.userInfo.organId,
        userName: keyword
      };
      return this.$http({
        url: '/buz/userBase/getSubUser',
        type: 'get',
        data: params
      }).then(res => {
        return res.data;
      });
    },
    // 获取团队列表
    getGroupList(data) {
      this.groupList = [];
      this.$http({
        url: '/buz/organizationGroup/listSubGroup',
        type: 'post',
        data: {
          organizationId: data
        }
      }).then(res => {
        this.groupList = res.data;
        this.searchParams.groupIds = [];
      });
    },
    changeOriginSupplierType(value) {
      this.searchParams.supplierIds = [];
      if (!value) {
        this.supplierList = [];
        return;
      }
      this.$http({
        url: value == 1 ? '/buz/insuranceCompany/read/list' : '/buz/insuranceChannel/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        if (value) {
          this.supplierList = res.data.map(i => {
            return {
              value: i.id,
              label: i.name
            };
          });
        } else {
          this.supplierList = [];
        }
      });
    },
    showReceiptRevisit(item) {
      if (item.receiptStatus && item.verifyStatus) {
        return this.RECEIPT_STATUS[item.receiptStatus] + this.VERIFY_STATUS[item.verifyStatus];
      } else if (item.receiptStatus) {
        return this.RECEIPT_STATUS[item.receiptStatus];
      } else if (item.verifyStatus) {
        return this.VERIFY_STATUS[item.verifyStatus];
      } else {
        return '无数据';
      }
    },
    // 切换tab重新调用导入接口
    getImport() {
      // this.$refs.importModal.changeTab = true;
      // this.$refs.importModal.startTask();
    },
    // 导入
    importModal() {
      this.$refs.importModal.open({
        template: '/buz/offlinePolicy/exportTemplate',
        upload: '/buz/offlinePolicy/importPolicy',
        apiPermissionCode: 'order_30_3'
      });
    },
    lookModal(item) {
      this.recordList = [];
      this.$http({
        url: '/buz/policyReceiptRecord/read/detail',
        type: 'GET',
        data: {
          policyNo: item.policyNo || ''
        }
      })
        .then(res => {
          this.recordList = res.data;
        })
        .catch(() => {
          this.recordList = [];
        });
    },
    copyCommon(url) {
      const cInput = document.createElement('input');
      cInput.value = url;
      document.body.appendChild(cInput);
      // 选取文本域内容;
      cInput.select();
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('Copy');
      this.$notice.success('复制成功');
      /// 复制成功后再将构造的标签 移除
      cInput.remove();
    },
    // 获取录单人
    getSysUserList() {
      this.$http({
        url: `/buz/policy/sysUserList`,
        type: 'POST',
        data: {}
      }).then(res => {
        this.sysUserList = res.data;
      });
    },
    // 获取保司列表
    getCompanyList() {
      this.$http({
        url: `/buz/insuranceCompany/read/list`,
        type: 'POST',
        data: { companyType: '1' }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {
        //机构
        this.searchParams.orgId = data.id;
        this.searchParams.groupId = '';
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.orgId = '';
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.orgId = '';
        this.searchParams.groupId = '';
      }
    },
    // 新增，编辑
    modifyPolicy(flag, row) {
      if (flag == 'add') {
        sessionStorage.reloadPolicyData = '1';
        this.$router.push({
          path: '/orderManage/insuredOrder/addPolicy',
          query: { pageFlag: flag }
        });
      } else if (flag == 'edit') {
        this.openPageTabTags('/orderManage/insuredOrder/editPolicy/' + row.policyNo, {
          pageFlag: flag,
          pageName: 'policyManage',
          id: row.id,
          policyNo: row.policyNo
        });
      } else if (flag == 'copy') {
        this.openPageTabTags('/orderManage/insuredOrder/copyPolicy/' + row.policyNo, {
          pageFlag: flag,
          pageName: 'policyManage',
          id: row.id,
          policyNo: row.policyNo
        });
      } else if (flag == 'delete') {
        this.$Modal.confirm({
          title: '删除',
          content: '<p>确认删除操作?</p>',
          loading: true,
          onOk: () => {
            this.$http({
              url: '/buz/offlinePolicy/delEnterPolicy',
              type: 'GET',
              data: { policyNo: row.policyNo },
              apiPermissionCode: 'order_30_6'
            })
              .then(res => {
                this.searchParams.pageNo = 1;
                this.getInsureList();
                this.$Modal.remove();
                this.$Message.success('删除成功');
              })
              .catch(err => {
                this.$Modal.remove();
              });
          }
        });
      }
    },
    handlerPolicyDetail(row) {
      this.$refs['policyDetailRef'].open(row);
    },
    // 下载电子保单
    confirmEmail() {
      this.$units.notCloseModal(this);
      // if(this.email)
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          this.showDownloadAll = false;
          const params = this.initFilterObj();
          const obj = {
            ...this.formValidate,
            ...params
          };
          this.$Spin.show();
          this.$http({
            type: 'POST',
            url: '/buz/policy/downloadAll',
            data: obj
          })
            .then(res => {
              this.$Spin.hide();
              this.$Message.success('文件已发送到您的邮箱');
            })
            .catch(() => {
              this.$Spin.hide();
            });
        }
      });
    },
    toShowDownModal() {
      this.showDownloadAll = true;
      this.$refs.formValidate.resetFields();
    },
    //获取电子保单
    async getPro(item) {
      const res = await this.$http({
        url: '/buz/policy/getDownloadUrl',
        type: 'GET',
        data: {
          policyNo: item.policyNo
        },
        apiPermissionCode: 'order_30_7'
      });
      if (res.data) {
        this.policyNo = res.data;
        const target = this.$refs.policyNoBox;
        this.$nextTick(() => {
          target.click();
        });
      }
    },
    async toggleSecondTab(index, item) {
      this.curActive = index;
      this.searchParams.secondTab = item.value;
      this.searchParams.pageNo = 1;
      if (this.searchParams.secondTab === this.copySecondTab) return;
      this.getInsureList();
    },
    pageChange(pageNo) {
      if (!this.isAll) {
        this.isCheckPage = false;
        this.checkAllGroup = [];
      }
      this.searchParams.pageNo = pageNo;
      this.getInsureList();
    },
    pageSizeChange(pageSize) {
      if (!this.isAll) {
        this.isCheckPage = false;
        this.checkAllGroup = [];
      }
      this.searchParams.pageNo = 1;
      this.searchParams.pageSize = pageSize;
      this.getInsureList();
    },

    //获取保单列表
    async getInsureList() {
      const params = this.initFilterObj();
      this.copyFirstTab = params.firstTab; //备份
      this.copySecondTab = params.secondTab;
      this.listLoading = true;
      this.$http({
        url: '/buz/policy/read/list',
        type: 'POST',
        data: params,
        apiPermissionCode: 'order_30_0'
      })
        .then(res => {
          res.data.forEach(item => {
            if (item.insuranceContract) {
              item.insuranceContract = JSON.parse(item.insuranceContract);
            }
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
            if (item.policyAdditionalList && item.policyAdditionalList.length > 0) {
              item.hasAdditional = true;
            }
            this.checkItemsList.forEach(item1 => {
              if (item.id == item1.id) {
                item._checked = true;
              }
            });
          });

          // 统计当前页选中的个数
          let checkPageLeng = res.data.filter(item => item._checked).length;
          if (checkPageLeng == res.data.length) {
            this.isCheckPage = true;
          }

          this.total = res.total;
          this.listLoading = false;
          this.insureList = res.data;
        })
        .catch(e => {
          console.log(e);
          this.listLoading = false;
        });
      const statisDate = await getInsureStatistics(params);
      this.countObj = statisDate.data;
      if (statisDate.data.policyNoList.length) {
        this.$refs.noPolicyNumberRef.open(statisDate.data.policyNoList);
      }
    },

    resetSearch() {
      this.searchParams = {
        isAbnormal: '0',
        applyOrgId: '',
        policyNo: '',
        isSelfHold: '',
        isMutualHold: '',
        dateType: '4',
        userType: '1',
        selectType: '1',
        pageNo: 1,
        pageSize: this.searchParams.pageSize,
        firstTab: this.copyFirstTab,
        secondTab: this.copySecondTab
      };
      this.searchAjax();
    },
    //搜索
    searchAjax() {
      this.searchParams.pageNo = 1;
      this.listLoading = true;
      this.isAll = false;
      this.checkAllGroup = [];
      this.checkItemsList = [];
      this.isCheckPage = false;
      this.getInsureList();
    },
    //获取最新搜索条件
    initFilterObj() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      if (params.date && params.date[0]) {
        if (params.dateType == 1) {
          //录单时间
          params.entryTimeBegin = params.date[0];
          params.entryTimeEnd = params.date[1];
        } else if (params.dateType == 2) {
          //投保日期
          params.holdTimeBegin = params.date[0];
          params.holdTimeEnd = params.date[1];
        } else if (params.dateType == 3) {
          //生效日期
          params.effectTimeBegin = params.date[0];
          params.effectTimeEnd = params.date[1];
        } else if (params.dateType == 4) {
          //承保时间
          params.insureTimeBegin = params.date[0];
          params.insureTimeEnd = params.date[1];
        } else if (params.dateType == 5) {
          //支付时间
          params.payTimeStart = params.date[0];
          params.payTimeEnd = params.date[1];
        }
      }
      delete params.selectType;
      delete params.dateType;
      delete params.date;
      if (params.userType == 1) {
        //投保人
        params.holderName = params.name;
      } else if (params.userType == 2) {
        //被保险人
        params.insuranceName = params.name;
      }
      // 保单号
      if (params.policyNoList && params.policyNoList.split('\n').filter(item => item).length) {
        params.policyNoList = params.policyNoList.split('\n').filter(item => item);
      }
      delete params.userType;
      delete params.name;
      delete params.applyOrgId;
      return params;
    },
    dropdownClick(e, item) {
      if (e == 'delete') {
        this.modifyPolicy('delete', item);
      } else if (e == 'change') {
        this.$refs.changeRecord.open(item);
      } else if (e == 'policy') {
        this.getPro(item);
      } else if (e == 'underlinePolicy') {
        this.goUnderlinePolicy(item);
      } else if (e == 'copy') {
        this.modifyPolicy('copy', item);
      } else if (e == 'policyVideo') {
        this.policyVideo(item);
      } else if (e == 'associationChannel') {
        this.associationChannel(item);
      }
    },
    // 关联合伙渠道
    associationChannel(item) {
      this.$refs.associationChannelRef.open(item);
    },
    // 调整保单回溯
    //isCheck是否校验成功
    policyVideo(item, isCheck = false) {
      let check = isCheck;
      if (!this.$units.pointAction('order_30_12')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      if (localStorage.POLICY_INFO_CHECK) {
        //验证码缓存有效期一天
        let data = JSON.parse(localStorage.getItem('POLICY_INFO_CHECK'));
        if (data.date == dayjs().format('YYYY-MM-DD') && data.userId == JSON.parse(localStorage.getItem('userInfo')).userid) {
          check = true;
        } else {
          localStorage.removeItem('POLICY_INFO_CHECK');
        }
      }
      if (!check) return this.$refs.infoCheckRef.open(item);
      this.$http({
        url: '/buz/policy/getIff',
        type: 'GET',
        data: {
          policyNo: item.policyNo
        },
        apiPermissionCode: 'order_30_0'
      }).then(res => {
        window.open(res.data);
      });
    },
    // 获取文件类型
    checkType(path) {
      return path && path.split('.').pop().toLowerCase();
    },
    // 线下单子保单
    goUnderlinePolicy(item) {
      if (item.dockChannel == 3) {
        // 凤栖的单
        this.$units.downloadFile('/buz/policy/downloadFqyfPolicy', { policyNo: item.policyNo }, 'GET');
        return;
      }
      if (item.insuranceContract.length > 1) {
        this.urlList = item.insuranceContract.map(i => {
          return { path: i, fileName: i.split('/')[i.split('/').length - 1] };
        });
        this.showPolicy = true;
      } else {
        let path = item.insuranceContract[0];
        if (['png', 'jpg', 'jpeg'].includes(this.checkType(path))) {
          this.urlList = item.insuranceContract.map(i => {
            return { path: i, fileName: i.split('/')[i.split('/').length - 1] };
          });
          this.showPolicy = true;
        } else {
          window.open(path, '_blank');
        }
      }
    },
    getList() {
      this.getInsureList();
      this.getCompanyList();
      this.getSysUserList();
    },
    // 选中所有
    handleCheckAll() {
      this.isCheckPage = this.isAll;
      const insureList = JSON.parse(JSON.stringify(this.insureList));
      insureList.forEach(item => {
        item._disabled = this.isAll;
        item._checked = this.isAll;
      });
      this.insureList = insureList;
      this.checkAllGroup = [];
      this.checkItemsList = [];
    },
    // 选中当前页
    handleCheckPage() {
      this.isAll = false;
      if (this.isCheckPage) {
        const arr = this.insureList.filter(item => item.id && item.sourceType != 2 && item.entrance != 2);
        this.checkAllGroup = arr.map(item => item.id);
        this.insureList.forEach(item => {
          item._checked = true;
        });
        // 获取所有已选的id
        let checkedIds = this.checkItemsList.map(item => item.id);
        // 循环当前页列表，去掉之前已选的数据，把未选的数据添加到选中数组中
        this.insureList.map(item => {
          if (!checkedIds.includes(item.id)) {
            this.checkItemsList.push(item);
          }
        });
      } else {
        this.checkAllGroup = [];
        this.insureList.forEach(item => {
          item._checked = false;
        });

        // 获取当前页id集合，并从已选数组中删除掉
        let tableListIds = this.insureList.map(item => item.id);
        this.checkItemsList = this.checkItemsList.filter(item => !tableListIds.includes(item.id));
      }
    },
    // 选中当前
    handleCheckItem(value, item) {
      if (value) {
        this.checkAllGroup.push(item.id);
        // 把当前已选中的数据存放到数组中
        this.checkItemsList.push(item);

        // 获取当前页选中的个数
        let len = this.insureList.filter(item => item._checked).length;
        if (len == this.insureList.length) {
          this.isCheckPage = true;
        }
      } else {
        // 当前页选中数据不等于分页条页，去掉当前页选中
        this.checkAllGroup = this.checkAllGroup.filter(data => data != item.id);
        if (this.checkAllGroup.length != this.insureList.length) {
          this.isCheckPage = false;
        }
        // 从已选中删除掉当前去掉选中的数据
        this.checkItemsList = this.checkItemsList.filter(data => data.id != item.id);
      }
    },
    // 批量删除
    batchDelete() {
      if (this.checkItemsList.length == 0 && !this.isAll) {
        this.$notice.msg('请至少选择一条保单');
        return;
      }
      var msg = '';
      let ids = [];
      // 单选
      if (!this.isAll && this.checkItemsList.length == 1) {
        this.insureList.forEach(item => {
          if (this.checkItemsList.includes(item.id)) {
            if (item.sourceType != 2 && item.entrance != 2) {
              msg = '所选的保单包含平台单不可删除，是否确认删除其他非平台单?';
            } else {
              msg = '确认删除选中保单?';
              ids.push(item.id);
            }
          } else {
            msg = '所选的保单包含平台单不可删除，是否确认删除其他非平台单?';
          }
        });
      }

      // 多选
      if (!this.isAll && this.checkItemsList.length > 1) {
        let arr = this.checkItemsList.filter(item => item.sourceType == 2 && item.entrance == 2);
        ids = arr.map(item => item.id);
        if (this.checkItemsList.length == ids.length) {
          msg = '确认删除选中保单?';
        } else {
          msg = '所选的保单包含平台单不可删除，是否确认删除其他非平台单?';
        }
      }

      // 全选
      if (this.isAll) {
        this.$http({
          url: '/buz/policy/queryNums',
          type: 'POST',
          data: {
            ...this.initFilterObj()
          }
        }).then(res => {
          // 只有非平台单
          if (res.data.platNums == 0) {
            msg = '确认删除选中保单?';
          } else {
            msg = '所选的保单包含平台单不可删除，是否确认删除其他非平台单?';
          }
        });
      }
      setTimeout(() => {
        this.$notice.inquiry(msg).then(() => {
          this.listLoading = true;
          this.$http({
            url: '/buz/policy/delBatch',
            type: 'POST',
            data: {
              ...this.initFilterObj(),
              isAll: this.isAll ? 1 : 0,
              ids: this.isAll ? [] : ids
            }
          })
            .then(res => {
              this.searchAjax();
              this.$notice.success(`您已成功删除${res.data}条保单`);
            })
            .finally(e => {
              this.listLoading = false;
            });
        });
      }, 1000);
    }
  },
  activated() {
    // 首页带参数跳转过来
    if (this.$route.query.organizationId) {
      this.searchParams.applyOrgId = this.$route.query.organizationId;
      this.searchParams.orgId = this.$route.query.organizationId;
    }
    this.$nextTick(() => {
      this.$refs.selectTree && this.$refs.selectTree.openChange(true);
    });
    if (!this.$units.superviseShowVal()) {
      this.searchParams.supplierType = '1';
    }
    console.log(this.searchParams);
    this.getGroupList();
    this.getList();
    if (this.$units.isOkBao() || this.$units.isRYBB()) {
      this.getOkBaoSalesSupport();
    }
  }
};
</script>
<style lang="scss" scoped>
.policy {
  white-space: nowrap;

  &:hover {
    cursor: pointer;
  }
}

.items {
  margin-bottom: 15px;
}

// .inrWidth {
//   // flex: 0 0 300px !important;
// }

.verifyBox {
  background: #fff0ea;
  border: 1px solid #ffd8c7;
  padding: 4px;
  color: #ff7134;
  font-size: 12px;
  border-radius: 15px 15px 15px 0px;
  position: absolute;
  top: -12px;
  right: -63px;
}

/deep/ .ivu-modal-body {
  padding: 16px 30px;
}

/deep/ .formGroup {
  position: relative;

  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: '';
    filter: blur(5px);
    background: #fff;
  }

  padding: 0;

  .title {
    font-size: 13px;
    font-weight: bold;
    color: #3c464f;
  }
}

/deep/ .formGroup:after {
  display: none;
}

/deep/ .formGroup .title {
  font-size: 13px;
  color: #272933;
  margin-bottom: 0 !important;
  border-bottom: none !important;
}

/deep/ .ivu-modal-body {
  padding: 16px 30px;
}

/deep/ .formGroup {
  height: unset !important;
  position: relative;
  padding: 0;

  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: '';
    filter: blur(5px);
    background: #fff;
  }

  .title {
    font-size: 14px;
    font-weight: bold;
    color: #3c464f;
  }
}

.actionStyle {
  color: #236dff;
  font-size: 14px;
  display: inline-block;
  cursor: pointer;
  white-space: nowrap;
}
.my-modal /deep/ .title {
  width: 100%;
  padding-bottom: 10px;
  padding-top: 10px;
  font-size: 14px;
  color: #3c464f;
  font-weight: bold;
  position: relative;
  display: flex;
  align-items: center;
  white-space: nowrap;
  height: 40px;
  &::before {
    content: '';
    display: block;
    width: 3px;
    height: 14px;
    background-color: #236dff;
    margin-right: 6px;
  }

  &::after {
    content: '';
    display: block;
    background-color: #eff3fc;
    height: 1px;
    width: 100%;
    margin-left: 10px;
  }
}
/deep/ .ivu-poptip-body {
  overflow: auto;
  max-height: 400px;
}
@import './order.scss';
</style>
